<app-side-menu>
  <div class="cost-center-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <app-button 
              text="Voltar"
              color="var(--secondary-color)"
              (buttonClick)="cancel()"
              className="me-3">
              <i class="fas fa-arrow-left me-2"></i>
            </app-button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-chart-pie me-3"></i>
                {{ costCenterId ? 'Editar Centro de Custo' : 'Novo Centro de Custo' }}
              </h1>
              <p class="page-subtitle">{{ costCenterId ? 'Atualize as informações do centro de custo' : 'Cadastre um novo centro de custo no sistema' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row">
      <div class="col-12">
        <div class="cost-center-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Identificação -->
          <div *ngIf="currentStep === 1" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h3>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-3">
                <label for="code" class="form-label">Código *</label>
                <input 
                  type="text" 
                  id="code"
                  class="form-control"
                  formControlName="code"
                  [class.is-invalid]="isFieldInvalid('code') || codeExists"
                  [class.is-valid]="isFieldValidAndTouched('code') && !codeExists && !isCheckingCode"
                  placeholder="Ex: CC001">
                
                <div class="code-validation" *ngIf="code?.value && code?.value.length >= 2">
                  <div *ngIf="isCheckingCode" class="code-checking">
                    <i class="fas fa-spinner fa-spin me-1"></i>
                    Verificando...
                  </div>
                  <div *ngIf="!isCheckingCode && !codeExists" class="code-available">
                    <i class="fas fa-check me-1"></i>
                    Código disponível
                  </div>
                  <div *ngIf="!isCheckingCode && codeExists" class="code-exists">
                    <i class="fas fa-times me-1"></i>
                    Código já existe
                  </div>
                </div>
                
                <div class="invalid-feedback" *ngIf="isFieldInvalid('code') || codeExists">
                  {{ getFieldError('code') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="name" class="form-label">Nome *</label>
                <input 
                  type="text" 
                  id="name"
                  class="form-control"
                  formControlName="name"
                  [class.is-invalid]="isFieldInvalid('name')"
                  [class.is-valid]="isFieldValidAndTouched('name')"
                  placeholder="Nome do centro de custo">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                  {{ getFieldError('name') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="type" class="form-label">Tipo *</label>
                <select 
                  id="type"
                  class="form-select"
                  formControlName="type"
                  [class.is-invalid]="isFieldInvalid('type')"
                  [class.is-valid]="isFieldValidAndTouched('type')">
                  <option value="">Selecione o tipo</option>
                  <option *ngFor="let typeOption of costCenterTypes" [value]="typeOption">
                    {{ typeOption }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('type')">
                  {{ getFieldError('type') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="status" class="form-label">Status *</label>
                <select 
                  id="status"
                  class="form-select"
                  formControlName="status"
                  [class.is-invalid]="isFieldInvalid('status')"
                  [class.is-valid]="isFieldValidAndTouched('status')"
                  [disabled]="loadingStatuses">
                  <option value="">Selecione...</option>
                  <option *ngFor="let statusOption of statusOptions" [value]="statusOption.name">
                    {{ statusOption.name }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('status')">
                  {{ getFieldError('status') }}
                </div>
                <div *ngIf="loadingStatuses" class="form-text">
                  <i class="fas fa-spinner fa-spin me-1"></i> Carregando status...
                </div>
              </div>
              
              <div class="col-12">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control"
                  formControlName="description"
                  [class.is-invalid]="isFieldInvalid('description')"
                  [class.is-valid]="isFieldValidAndTouched('description')"
                  placeholder="Descrição detalhada do centro de custo"
                  rows="3"></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                  {{ getFieldError('description') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Organização -->
          <div *ngIf="currentStep === 2" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-sitemap me-2"></i>
              Hierarquia e Organização
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-6">
                <label for="parentId" class="form-label">Centro de Custo Pai</label>
                <select 
                  id="parentId"
                  class="form-select"
                  formControlName="parentId"
                  [class.is-invalid]="isFieldInvalid('parentId') || !!parentValidationError"
                  [class.is-valid]="isFieldValidAndTouched('parentId') && !parentValidationError && !isValidatingParent">
                  <option [ngValue]="null">Nenhum (Centro Raiz)</option>
                  <option *ngFor="let parent of parentCostCenters" [ngValue]="parent.id">
                    {{ parent.code }} - {{ parent.name }}
                  </option>
                </select>
                
                <div class="code-validation" *ngIf="parentId?.value && costCenterId">
                  <div *ngIf="isValidatingParent" class="code-checking">
                    <i class="fas fa-spinner fa-spin me-1"></i>
                    Validando hierarquia...
                  </div>
                  <div *ngIf="!isValidatingParent && !parentValidationError" class="code-available">
                    <i class="fas fa-check me-1"></i>
                    Hierarquia válida
                  </div>
                  <div *ngIf="!isValidatingParent && parentValidationError" class="code-exists">
                    <i class="fas fa-exclamation-triangle me-1"></i>
                    {{ parentValidationError }}
                  </div>
                </div>
                
                <div class="form-text" *ngIf="!parentValidationError">
                  Selecione um centro de custo pai para criar uma hierarquia
                </div>
                
                <div class="invalid-feedback" *ngIf="isFieldInvalid('parentId') || parentValidationError">
                  {{ getFieldError('parentId') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="departmentId" class="form-label">Departamento</label>
                <select
                  id="departmentId"
                  class="form-select"
                  formControlName="departmentId"
                  (change)="onDepartmentChange()"
                  [disabled]="loadingDepartments"
                  [class.is-invalid]="isFieldInvalid('departmentId')"
                  [class.is-valid]="isFieldValidAndTouched('departmentId')">
                  <option [ngValue]="null">Selecione o departamento</option>
                  <option *ngFor="let d of departments" [ngValue]="d.id">
                    {{ d.name }}{{ d.isActive === false ? ' (inativo)' : '' }}
                  </option>
                </select>
                <div class="form-text" *ngIf="loadingDepartments">
                  <i class="fas fa-spinner fa-spin me-1"></i>
                  Carregando departamentos...
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('departmentId')">
                  {{ getFieldError('departmentId') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="responsibleStaffId" class="form-label">Responsável</label>
                <select
                  id="responsibleStaffId"
                  class="form-select"
                  formControlName="responsibleStaffId"
                  [disabled]="loadingStaff"
                  [class.is-invalid]="isFieldInvalid('responsibleStaffId')"
                  [class.is-valid]="isFieldValidAndTouched('responsibleStaffId')">
                  <option [ngValue]="null">Selecione o colaborador</option>
                  <option *ngFor="let s of staffMembers" [ngValue]="s.Id">
                    {{ s.FullName }}{{ s.Department ? ' — ' + s.Department : '' }}
                  </option>
                </select>
                <div class="form-text" *ngIf="loadingStaff">
                  <i class="fas fa-spinner fa-spin me-1"></i>
                  Carregando colaboradores...
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('responsibleStaffId')">
                  {{ getFieldError('responsibleStaffId') }}
                </div>
              </div>

              <div class="col-md-4">
                <label for="budget" class="form-label">Orçamento (R$)</label>
                <input 
                  type="text" 
                  id="budget"
                  class="form-control"
                  formControlName="budget"
                  [readonly]="isEditMode"
                  [class.is-invalid]="isFieldInvalid('budget')"
                  [class.is-valid]="isFieldValidAndTouched('budget')"
                  placeholder="R$ 0,00"
                  (input)="onBudgetInput($event)">
                <div class="form-text text-muted" *ngIf="isEditMode">
                  Alteração de orçamento via proposta de orçamento.
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('budget')">
                  {{ getFieldError('budget') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="actualCost" class="form-label">Custo Real (R$)</label>
                <input 
                  type="text" 
                  id="actualCost"
                  class="form-control"
                  formControlName="actualCost"
                  [readonly]="isEditMode"
                  [class.is-invalid]="isFieldInvalid('actualCost')"
                  [class.is-valid]="isFieldValidAndTouched('actualCost')"
                  placeholder="R$ 0,00"
                  (input)="onActualCostInput($event)">
                <div class="form-text text-muted" *ngIf="isEditMode">
                  Valor consolidado pelo sistema; não editável aqui.
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('actualCost')">
                  {{ getFieldError('actualCost') }}
                </div>
              </div>

              <div class="col-md-4">
                <label for="startDate" class="form-label">Data de Início</label>
                <input 
                  type="date" 
                  id="startDate"
                  class="form-control"
                  formControlName="startDate">
                <div class="form-text">
                  Data de início de vigência do centro de custo
                </div>
              </div>

              <div class="col-md-6">
                <label for="endDate" class="form-label">Data de Fim</label>
                <input 
                  type="date" 
                  id="endDate"
                  class="form-control"
                  formControlName="endDate">
                <div class="form-text">
                  Data de fim de vigência (opcional)
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Status & Observações -->
          <div *ngIf="currentStep === 3" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-cog me-2"></i>
              Status e Configurações
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="isActive"
                    class="form-check-input" 
                    formControlName="isActive">
                  <label for="isActive" class="form-check-label">
                    <strong>Centro de Custo Ativo</strong>
                  </label>
                </div>
                <div class="form-text">
                  Desmarque para desativar temporariamente este centro de custo
                </div>
              </div>

              <div class="col-12">
                <label for="notes" class="form-label optional">Observações</label>
                <textarea 
                  id="notes"
                  class="form-control" 
                  formControlName="notes"
                  [class.is-invalid]="isFieldInvalid('notes')"
                  [class.is-valid]="isFieldValidAndTouched('notes')"
                  rows="4"
                  placeholder="Observações gerais sobre o centro de custo..."></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('notes')">
                  {{ getFieldError('notes') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Botões de Ação - SEMPRE VISÍVEIS -->
          <div class="form-actions">
            <div class="wizard-actions">
              <!-- Botão Voltar -->
              <button 
                type="button"
                class="btn btn-outline-secondary"
                (click)="prevStep()"
                [disabled]="currentStep === 1">
                Voltar
              </button>
              
              <div class="spacer"></div>
              
              <!-- Botão Cancelar -->
              <button 
                type="button"
                class="btn btn-outline-danger"
                (click)="cancel()">
                Cancelar
              </button>
              
              <!-- Botão Avançar (apenas nos steps 1 e 2) -->
              <button 
                *ngIf="currentStep < 3"
                type="button"
                class="btn btn-primary"
                (click)="nextStep()">
                Avançar
              </button>
              
              <!-- Botão Salvar (apenas no step 3) -->
              <button 
                *ngIf="currentStep === 3"
                type="button"
                class="btn btn-primary"
                (click)="save()"
                [disabled]="isSubmitting">
                <i class="fas fa-save me-2" *ngIf="!isSubmitting"></i>
                <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmitting"></i>
                Salvar Centro de Custo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
